import { FC, PropsWithChildren, useMemo } from "react";
import { useRecoilValue } from "recoil";

import { useCrudEditContext } from "@ryde/redux";
import { IExtendableDto, loadersEditFormWithApiDataSF } from "@ryde/shared";

export const BookingEditWrapper: FC<PropsWithChildren> = ({ children }) => {
  const loadingAllData = useRecoilValue(
    loadersEditFormWithApiDataSF("booking"),
  );
  const {
    data: { dto },
  } = useCrudEditContext<IExtendableDto>();

  const isBookingFormDataLoaded = useMemo(() => {
    return !loadingAllData && Boolean(dto);
  }, [dto, loadingAllData]);

  return isBookingFormDataLoaded ? children : null;
};
